import { gql } from "@apollo/client";

export const GET_VOTING_INFORMATION_BASIS = gql`
    query GetVotingInformationBasis($language: String = "de") {
        common_key_mls(where: { language: { _eq: $language }, _and: { key: { active: { _eq: true } } } }) {
            keyid
            name
            key {
                type
            }
        }
    }
`;

export const INSERT_VOTING_INFORMATION_BASIS = gql`
    mutation InsertVotingInformationBasis($objects: [survey_votings_insert_input!]!) {
        insert_survey_votings(
            objects: $objects
            on_conflict: { constraint: PK_votings, update_columns: [key1id, key2id, quorum, veto, majority, entirety] }
        ) {
            returning {
                id
                voting_mls {
                    title
                    question
                }
            }
        }
    }
`;

export const INSERT_VOTING_OPTION_AGENDAITEM = gql`
    mutation InsertVotingOptions(
        $votingid: uuid!
        $keepAgendaitemIds: [uuid!]!
        $objectVotingOptions: [survey_votingoptions_insert_input!]!
        $objectVotingAgendaitems: [survey_votingagendaitems_insert_input!]!
        $objectRealestates: [survey_votingagendaitemrealestates_insert_input!]!
    ) {
        delete_survey_votingoptions(where: { votingid: { _eq: $votingid } }) {
            affected_rows
        }
        insert_survey_votingoptions(objects: $objectVotingOptions) {
            returning {
                id
            }
        }
        insert_survey_votingagendaitems(
            objects: $objectVotingAgendaitems
            on_conflict: { constraint: PK_votingagendaitems, update_columns: [] }
        ) {
            returning {
                id
                sort
            }
        }
        delete_survey_votingagendaitemrealestates(where: { votingagendaitemid: { _in: $keepAgendaitemIds } }) {
            affected_rows
        }
        insert_survey_votingagendaitemrealestates(objects: $objectRealestates) {
            affected_rows
        }
    }
`;

export const DELETE_VOTING = gql`
    mutation DeleteVoting($votingId: uuid!) {
        delete_survey_votings(where: { id: { _eq: $votingId } }) {
            affected_rows
        }
    }
`;

export const GET_VOTINGS_BY_AGENDAITEMID = gql`
    query GetVotingsByAgendaitemId($agendaitemid: uuid!) {
        survey_v_votings_by_agendaitem(where: { agendaitemid: { _eq: $agendaitemid } }) {
            votingid
            votingagendaitemid
            question
            title
        }
    }
`;

export const GET_VOTING_TENANTS_OPTIONS_RESULTS = gql`
    query GetVotingTenantsAndOptionsAndResults($votingagendaitemid: uuid!, $votingid: uuid!) {
        survey_v_votingtenantdetails(where: { votingagendaitemid: { _eq: $votingagendaitemid } }) {
            tenantid
            name
            option
            unitvalue: sum_unitvalue
            unitcounter
        }
        survey_votingagendaitemresults(
            where: { votingagendaitemrealestate: { votingagendaitemid: { _eq: $votingagendaitemid } } }
        ) {
            id
            state
            unitid
            votingagendaitemrealestateid
            tenantid
            votingoptionid
        }
        survey_votingoptions(where: { votingid: { _eq: $votingid } }, order_by: { sort: asc_nulls_last }) {
            id
            sort
            votingoption_mls {
                language
                votingoptionid
                text
            }
        }
    }
`;

export const GET_VOTING_OPTIONS = gql`
    query GetVotingOptions($votingid: uuid!) {
        survey_votingoptions(where: { votingid: { _eq: $votingid } }, order_by: { sort: asc_nulls_last }) {
            id
            sort
            votingoption_mls {
                language
                votingoptionid
                text
            }
        }
    }
`;

export const UPSERT_VOTING_AGENDA_RESULTS = gql`
    mutation UpsertVotingAgendaitemResult($votingagendaitemresults: [survey_votingagendaitemresults_insert_input!]!) {
        insert_survey_votingagendaitemresults(
            objects: $votingagendaitemresults
            on_conflict: { constraint: PK_votingagendaitemresults, update_columns: [votingoptionid, state] }
        ) {
            affected_rows
        }
    }
`;

export const GET_VOTING_DETAILS = gql`
    query GetVotingDetails($votingid: uuid!, $agendaitem: uuid!, $language: String = "de") {
        survey_votings(where: { id: { _eq: $votingid } }) {
            id
            veto
            entirety
            quorum
            key1id
            key1 {
                key_mls(where: { language: { _eq: $language } }) {
                    name
                }
            }
            key2id
            key2 {
                key_mls(where: { language: { _eq: $language } }) {
                    name
                }
            }
            votetype
            majority
            votingagendaitems(where: { agendaitemid: { _eq: $agendaitem } }) {
                votingagendaitemrealestates {
                    realestateid
                }
            }
            voting_mls {
                id
                language
            }
        }
    }
`;

export const UPDATE_VOTETYPE_VOTINGS = gql`
    mutation UpdateVotetypeVotings($id: uuid!, $votetype: Int!) {
        update_survey_votings(where: { id: { _eq: $id } }, _set: { votetype: $votetype }) {
            affected_rows
            returning {
                id
                votetype
            }
        }
    }
`;
